import { render, staticRenderFns } from "./BackupResume.vue?vue&type=template&id=13402766"
import script from "./BackupResume.vue?vue&type=script&lang=js"
export * from "./BackupResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports